































import Vue from 'vue';
import { mapGetters } from 'vuex';
import ArrowRightIcon from 'vue-material-design-icons/ArrowRight.vue';
import SquareEditOutlineIcon from 'vue-material-design-icons/SquareEditOutline.vue';
import pxCard from '@/dex-shared/components/px-card.vue';

export default Vue.extend({
  components: {
    pxCard,
    ArrowRightIcon,
    SquareEditOutlineIcon,
  },

  computed: {
    ...mapGetters({
      examGroup: 'currentExamGroup',
      exams: 'currentExamGroupExams',
    }),
    link() {
      if (this.examGroup.slug) {
        return `https://simulado.descomplica.com.br/provas/${this.examGroup.slug}`;
      }
      return '';
    },
  },

  created() {
    let examGroupId = parseInt(this.$route.params.examGroupId);
    if (!examGroupId) examGroupId = 6; //TODO landing page
    this.$store.dispatch('PULL_EXAM_GROUP', examGroupId);
  },
});
